import { IconButton, Tooltip } from '@civilgrid/ui/components';
import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { AgencyLink } from '~/common/types';
import { Notify } from '~/components2/Notify';
import store from '../../../store';
import { subGeometryDisplayName } from '../../subGeometries/helpers';
import { linkTypeMap } from './common';
import DeleteLink from './DeleteLink';
import EditLink from './EditLink';

const getUrlCell = (cell: CellContext<AgencyLink, unknown>) => {
  return (
    <div className="flex w-full justify-start space-x-1">
      <Tooltip asChild text="Copy link URL">
        <IconButton
          variant="hollow"
          icon="copy"
          size="icon"
          aria-label="Copy link URL"
          onClick={() => {
            const url = cell.row.original.url;
            navigator.clipboard.writeText(url);
            Notify.info({ message: `Copied ${url} to clipboard` });
          }}
        />
      </Tooltip>

      <div>{cell.getValue<string>() || 'NO URL!'}</div>
    </div>
  );
};

export const columns: ColumnDef<AgencyLink>[] = [
  { id: 'title', header: 'Title', accessorKey: 'title' },
  { id: 'description', header: 'Description', accessorKey: 'description' },
  {
    id: 'url',
    header: 'URL',
    accessorKey: 'url',
    cell: getUrlCell,
    minSize: 300,
  },
  {
    id: 'subRegion',
    header: 'Sub-region',
    accessorFn: (link) => {
      if (!link.agencySubGeometryId) return '';
      return subGeometryDisplayName(store.subGeometries.find((sg) => sg.id === link.agencySubGeometryId)?.name);
    },
  },
  {
    id: 'type',
    header: 'Type',
    accessorFn: ({ type }) => linkTypeMap[type] || '',
  },
  {
    id: 'isPrivate',
    header: 'Private',
    accessorFn: ({ isPrivate }) => (isPrivate ? '✅' : ''),
  },
  {
    id: 'actions',
    header: 'Actions',
    size: 100,
    cell: (cell) => {
      const link = cell.row.original;

      return (
        <div className="flex items-center justify-start space-x-2">
          <EditLink link={link} />
          <DeleteLink link={link} />
        </div>
      );
    },
  },
];
